exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".perf-tool.container{position:fixed;width:100%;height:200px;border:1px solid #ddd;background-color:#fff;z-index:50000000;font-family:Helvetica,sans-serif}.perf-tool.container.bottom{right:0;bottom:0;left:0}.perf-tool.container.bottom.hidden{bottom:-200px}.perf-tool .resize-handler{width:100%;height:10px;position:absolute;top:-3px;right:0;left:0;cursor:row-resize}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/styles/container.css
 ** module id = 204
 ** module chunks = 0
 **/